import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'

import Home from '../views/Home'
import Schedule from "../views/Schedule"
import NotFound from '../views/404'
import Login from "../views/Login"
import Reservations from "../views/Reservations";
import ReservationSingle from "../views/ReservationSingle";
import Items from "../views/Items";
import Shop from "../views/Shop"
import ShopCategory from "../views/ShopCategory";
import ShopTrainer from "../views/ShopTrainer";
import ChangeClub from "@/views/ChangeClub.vue";
import Documents from "../views/Documents";
import Cards from "../views/Cards";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'Личный кабинет'
        }
    },
    {
        path: '/schedule',
        name: 'Schedule',
        component: Schedule,
        meta: {
            title: 'Расписание'
        }
    },
    {
        path: '/reservations',
        name: 'Reservations',
        component: Reservations,
        meta: {
            title: 'Мои записи'
        }
    },
    {
        path: '/reservations/:id',
        name: 'ReservationSingle',
        component: ReservationSingle,
        meta: {
            title: 'Информация о занятии'
        }
    },
    {
        path: '/items',
        name: 'Items',
        component: Items,
        meta: {
            title: 'Мои абонементы и услуги'
        }
    },
    {
        path: '/shop',
        name: 'Shop',
        component: Shop,
        meta: {
            title: 'Магазин'
        }
    },
    {
        path: '/shop/category/:categoryId',
        name: 'ShopCategory',
        component: ShopCategory,
        meta: {
            title: 'Категория'
        },
        props: true
    },
    {
        path: '/shop/category/:categoryId/trainer/:trainerId',
        name: 'ShopTrainer',
        component: ShopTrainer,
        meta: {
            title: 'Категория'
        }
    },
    {
        path: '/shop/schedule/:scheduleId',
        name: 'ShopSchedule',
        component: () => import('@/views/Shop.vue'),
        meta: {
            title: 'Магазин по занятию'
        },
        props: true
    },
    {
        path: '/shop/schedule/:scheduleId/category/:categoryId',
        name: 'ShopScheduleCategory',
        component: ShopCategory,
        meta: {
            title: 'Категория по занятию'
        },
        props: true
    },
    {
        path: '/shop/schedule/:scheduleId/category/:categoryId/trainer/:trainerId',
        name: 'ShopScheduleTrainer',
        component: ShopTrainer,
        meta: {
            title: 'Категория по занятию'
        }
    },
    {
        path: '/changeClub',
        name: 'ChangeClub',
        component: ChangeClub,
        meta: {
            title: 'Смена филиала'
        }
    },
    {
        path: '/docs',
        name: 'Documents',
        component: Documents,
        meta: {
            title: 'Документы'
        }
    },
    {
        path: '/cards',
        name: 'Cards',
        component: Cards,
        meta: {
            title: 'Мои карты'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            layout: 'login-layout',
            title: 'Вход в личный кабинет'
        }
    },
    {
        path: '/404',
        name: 'NotFound',
        component: NotFound,
        meta: {
            title: 'Ошибка 404'
        }
    },
    {
        path: "/:catchAll(.*)",
        redirect: '/404',
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else if (savedPosition) {
            document.body.style.minHeight = Number(savedPosition.top) + Number(window.innerHeight) + "px";
            return savedPosition
        }else{
            document.body.style.minHeight = "";
        }
    },
})

router.beforeEach((to, from, next) => {
    //window.scrollTo(0, 0)

    if(to.name === 'Login' && localStorage.getItem('fitbase_token')){
        next({ name: 'Home' })
    }else if (to.name !== 'Login' && !localStorage.getItem('fitbase_token')){
        if (to.name === 'Schedule' || to.name === 'Documents'){
            next()
        }else{
            next({ name: 'Login' })
        }
    }else{
        next()
    }

    if (from.name === 'Schedule'){
        this.$store.dispatch('loadReservations')
    }
})

router.afterEach((to) => {
    let title = to.meta.title || 'Личный кабинет';
    document.title = title + ' | FitBase';

    store.commit('HIDE_MENU')
    store.dispatch('closeModals')
});

export default router
